import React from 'react';

export interface SkeletonProps {
  count?: number;
  className?: string;
}

export function Skeleton({ count = 1, className = '' }: SkeletonProps) {
  return (
    <div className={`animate-pulse space-y-4 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="h-4 bg-gray-200 dark:bg-gray-800 rounded w-3/4"></div>
      ))}
    </div>
  );
}
